import { create } from "zustand";

type LoadingState = {
	isLoading: boolean;
	setIsLoading: (v: boolean) => void;
};

export const useLoadingStore = create<LoadingState>((set) => ({
	isLoading: false,
	setIsLoading: (v) => set({ isLoading: v }),
}));
